import { render, staticRenderFns } from "./DestinationGroupDetail.vue?vue&type=template&id=79009b96"
import script from "./DestinationGroupDetail.vue?vue&type=script&lang=ts"
export * from "./DestinationGroupDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports